<div class="flex flex-col" *transloco="let t">
  <div class="flex max-w-300 flex-col gap-4 px-4">
    @if (isUpdatingAudiences()) {
      <div class="flex w-full items-center justify-center">
        <div class="text-muted-foreground flex items-center gap-2">
          <ISpinner />
          {{ t("dsp-audiences-page.updating_audiences") }}
        </div>
      </div>
    } @else {
      @if (!allowPreset()) {
        <div class="flex flex-col">
          <div class="mb-4 flex flex-1 justify-end">
            <button
              iButton
              variant="secondary"
              testId="btn-edit-dsp-audiences"
              [disabled]="isReadOnly()"
              (click)="openManualAudienceEditModal()"
            >
              <IIcon name="edit" />
              {{ t("dsp-audiences-selector.manage_audiences") }}
            </button>
          </div>
          <div class="flex flex-col rounded-lg border p-4">
            <div class="flex items-center">
              <h4>{{ t("common.audiences") }}</h4>
            </div>
            <div>
              <app-dsp-audience-list
                [audiences]="whitelistedAudiences()"
                [audienceType]="StrategyDspAudienceType.WHITELIST"
              />
            </div>
            <div class="mt-8 flex items-center">
              <h4>{{ t("dsp-strategy-page.audience_blacklist") }}</h4>
            </div>
            <div class="max-h-80 overflow-x-clip overflow-y-auto">
              <app-dsp-audience-list
                [audiences]="blacklistedAudiences()"
                [audienceType]="StrategyDspAudienceType.BLACKLIST"
              />
            </div>
          </div>
        </div>
      } @else {
        <div class="mx-auto flex max-w-3xl flex-col gap-4">
          <div class="flex w-full items-center justify-between">
            <div>
              {{ t("common.audiences") }}
            </div>
            @let hasModifiedAudiencePreset = strategy()?.audiencePreset !== audiencePresetControl.value;
            <div class="flex gap-2" [class.opacity-0!]="!hasModifiedAudiencePreset">
              <button iButton variant="secondary" (click)="cancelChanges()">
                {{ t("common.cancel") }}
              </button>
              <button
                iButton
                [disabled]="!hasModifiedAudiencePreset || isUpdatingAudiences() || isReadOnly()"
                [loading]="isUpdatingAudiences()"
                (click)="saveSmartAudienceSelection()"
              >
                {{ t("common.save") }}
              </button>
            </div>
          </div>
          <app-dsp-smart-audience-selector
            [selectedPreset]="audiencePresetControl.value"
            (selectedPresetChange)="audiencePresetControl.setValue($event)"
            [existingAudienceConfig]="existingAudienceConfig()"
            [disabled]="isReadOnly()"
            (manualAudienceSelected)="openManualAudienceCreationModal()"
            (manageAudiencesSelected)="openManualAudienceEditModal()"
          />
        </div>
      }
    }
  </div>
</div>
